import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Inbox.css';
import Inbox from '../../components/Inbox';
import { withQuery } from '../../hoc/withGraphql';

// Graphql 
import AllThreadsQuery from './AllThreadsQuery.graphql';
class InboxContainer extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    allThreads: PropTypes.object
  };

  render() {
    const { allThreads } = this.props;
    return (

      <div className={s.container}>
        <Inbox allThreads={allThreads} />
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  withQuery(AllThreadsQuery, {
    name: 'allThreads',
    options: {
      variables: {
        currentPage: 1
      },
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(InboxContainer);
